import { createTheme } from "@material-ui/core/styles";
import dayjs from "dayjs";
import * as yup from "yup";
import initials from "name-initials";
import htmr from "htmr";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";

dayjs.extend(isToday);
dayjs.extend(isYesterday);

const theme = createTheme({});

const screenUp = breakpoint => theme.breakpoints.up(breakpoint);
const screenDown = breakpoint => theme.breakpoints.down(breakpoint);

const isEuro = currency => currency === "EUR";

/**
 * @deprecated Use {@link useFormatPrice} instead.
 */
const formatPrice = (price, includeCurrency = false) => {
  const { currency = "EUR", amount = 0 } = price || {};
  const locale = currency === "EUR" ? "de-DE" : "en-US";
  const formattedPrice = new Intl.NumberFormat(locale, {
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount);

  if (!includeCurrency) return formattedPrice;

  return isEuro(currency) ? `€ ${formattedPrice}` : `$ ${formattedPrice}`;
};

const parseDateTime = (value, { t, format = false }) => {
  if (!value) return "";
  const date = dayjs(new Date(value));

  const time = dayjs(date).format("HH:mm");
  if (date.isYesterday()) {
    return t("yesterday", { time });
  }

  if (date.isToday()) {
    return format ? `${t("today", { time })}` : time;
  }

  return format
    ? dayjs(date).format("DD-MM-YYYY HH:mm")
    : `${dayjs(date).fromNow()} ${time}`;
};

const yupPassword = () =>
  yup
    .string()
    .min(8, "min8")
    .matches(/[0-9]+/, "digits")
    .matches(/[a-z]+/, "lowercase")
    .matches(/[A-Z]+/, "uppercase");

const AuctionStates = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
  CANCELED: "CANCELED",
  EXPIRED: "EXPIRED",
  RESERVED: "RESERVED",
  COMPLETED: "COMPLETED",
  BANNED: "BANNED",
  BID_ONLY: "BID_ONLY",
  COMING_SOON: "COMING_SOON",
};

const ProductStates = {
  DRAFT: "DRAFT",
  CURATION: "CURATION",
  REJECTED: "REJECTED",
  BANNED: "BANNED",
  CANCELED: "CANCELED",
  ACCEPTED: "ACCEPTED",
};

const getInitials = name => {
  if (!name) return "";
  return initials(name);
};

const isHexLight = (color, treshold = 155) => {
  const hex = color.replace("#", "");
  const c_r = parseInt(hex.substr(0, 2), 16);
  const c_g = parseInt(hex.substr(2, 2), 16);
  const c_b = parseInt(hex.substr(4, 2), 16);
  const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;
  return brightness > treshold;
};

const renderHTML = (markup = "") => {
  return htmr(markup.replace(/\\n/g, "<br>"));
};

export {
  yup,
  getInitials,
  parseDateTime,
  formatPrice,
  renderHTML,
  isHexLight,
  screenDown,
  screenUp,
  theme,
  yupPassword,
  AuctionStates,
  ProductStates,
};
